@use '@lib/assets/styles/main.scss' as *;
.actionView {
  border: 1px solid $gray200;
  border-radius: 6px;
  overflow: hidden;
}

.actionViewHeader {
  border-bottom: 1px solid $gray100;
  display: grid;
  grid-template-columns: auto min-content min-content;
  grid-column-gap: 8px;
  align-items: center;
  padding: 12px 8px 12px 16px;
}

.actionAssignees {
  border-bottom: 1px solid $gray100;
  padding: 12px 8px 12px 16px;
}

.dateUpdated {
  color: $gray400;
  padding-left: 32px;
}

.actionViewBody {
  background-color: $gray10;
}

.actionViewBodyContent {
  padding: 12px;
}

.tabBar {
  margin-bottom: 0;
}

.actionDescription {
  color: $gray700;
  padding: 12px;
}
